import { SAITAMA_CITY_SEASON_ID } from "../../config/SaitamaCityConfig";

export const buildSaitamaPhotoScope = (photoAlias = "ppa") => `
  ${photoAlias}.game_space_id = '${SAITAMA_CITY_SEASON_ID}'
  AND EXISTS (
    SELECT 1
    FROM power_asset_detail_of_saitama_city sc
    JOIN street_light sl ON sl.id = sc.power_asset_id
    WHERE sc.power_asset_id = ${photoAlias}.power_asset_id
  )
`;

export const buildSaitamaReportScope = (reportAlias = "rr") => `
  ${reportAlias}.game_space_id = '${SAITAMA_CITY_SEASON_ID}'
  AND EXISTS (
    SELECT 1
    FROM power_asset_detail_of_saitama_city sc
    JOIN street_light sl ON sl.id = sc.power_asset_id
    WHERE sc.power_asset_id = ${reportAlias}.power_asset_id
  )
`;
